import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, H4 } from '..';
import { FormattedMessage } from '../../util/reactIntl';
import css from './PaymentStatusModal.module.css';

const PaymentStatusModal = props => {
  const { isOpen, onClose, onManageDisableScrolling, onPaymentSuccess, onPaymentFailed } = props;

  return (
    <Modal
      id="payment-status-modal"
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <div className={css.contentWrap}>
        <H4 className={css.title}>
          <FormattedMessage id="PaymentStatusModal.title" />
        </H4>
        <p className={css.description}>
          <FormattedMessage id="PaymentStatusModal.description" />
        </p>
        <Button className={css.submitButton} type="submit" onClick={onPaymentSuccess}>
          <FormattedMessage id="PaymentStatusModal.continue" />
        </Button>
      </div>
    </Modal>
  );
};

PaymentStatusModal.propTypes = {
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onManageDisableScrolling: PropTypes.func.isRequired,
};

export default PaymentStatusModal;
